  <template>
    <div id="app">
      <img alt="Vue logo" src="./assets/gig.jpg">
      <!-- <h1>HI!</h1> -->
      <!-- <HelloWorld msg="Welcome to Your Vue.js App"/> -->
      <div class="contents">
        <router-view/>
        <router-link to="/logout">logout</router-link>
      </div>
    </div>
  </template>

  <script>
  // import HelloWorld from './components/HelloWorld.vue'
  // export default {
  //   name: 'App',
  //   components: {
  //     HelloWorld
  //   }
  // }
  export default {
    name: 'app'
  }
  </script>

  <style>
  #app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 60px;
  }
  </style>
